import { onBoardingState } from '@/services/Datatypes'
import { StateCreator } from 'zustand'

export interface ArticleModalZustandSlice {
    isVisible: boolean
    articleId: string
    date: string
    edition: string

    updateIsVisible: (isVisible: boolean) => void
    updateArticleId: (articleId: string) => void
    updateDate: (date: string) => void
    updateEdition: (edition: string) => void

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createArticleModalZustandSlice: StateCreator<ArticleModalZustandSlice> = (set, get) => ({
    isVisible: false,
    articleId: '',
    date: '',
    edition: '',

    updateIsVisible: (isVisible: boolean) => set(() => ({ isVisible: isVisible })),
    updateArticleId: (articleId: string) => set(() => ({ articleId: articleId })),
    updateDate: (date: string) => set(() => ({ date: date })),
    updateEdition: (edition: string) => set(() => ({ edition: edition })),

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});
